import API, { graphqlOperation } from '@aws-amplify/api';

const getUserStatusQuery = `query GetUserStatus($version: String!) {
  getUserStatus(version: $version) {
    accepted
    version
    identityId
  }
}
`;

const setUserAcceptance = `mutation SetUserAcceptance($input: setUserAcceptanceInput!) {
  setUserAcceptance(input: $input) {
    accepted
    version
    identityId
  }
}
`;

export const userHasAccepted = async () => {
  // query with PPV
  const params = {
    version: process.env.REACT_APP_PRIVACY_POLICY_VERSION,
  };
  const queryResult = await API.graphql(graphqlOperation(getUserStatusQuery, params));
  const data = queryResult.data.getUserStatus;
  return Boolean(data);
};

export const privacyPolicyAccept = async _ => {
  const params = {
    input: {
      version: process.env.REACT_APP_PRIVACY_POLICY_VERSION,
    },
  };
  const result = await API.graphql(graphqlOperation(setUserAcceptance, params));
  return Boolean(result.data.setUserAcceptance && result.data.setUserAcceptance.acceptance);
};
